import { useLocalization } from '@/hooks/useLocalization';
import { capitalize } from 'lodash';
import moment from 'moment';
import { useLocale, useTranslations } from 'next-intl';

export default function DeliveryTimeLabel() {
  const t = useTranslations('shop');
  const locale = useLocale();

  const {
    isAsap,
    isEcommerce,
    isPreorder,
    asapDeliveryOption,
    preorderDeliveryOption,
  } = useLocalization();

  function getPreorderLabel() {
    const now = moment().locale(locale);
    const hour = preorderDeliveryOption!.locale(locale).format('HH:mm');
    const day = capitalize(
      preorderDeliveryOption!.locale(locale).format('dddd'),
    );

    if (preorderDeliveryOption!.date() === now.date()) {
      return (
        <div className="truncate">
          <span>{t('deliveryTime.preorderToday')}</span>
          <span className="text-primary font-bold">{hour}</span>
        </div>
      );
    }
    if (moment(now).add(1, 'day').date() === preorderDeliveryOption!.date()) {
      return (
        <div className="truncate">
          <span>{t('deliveryTime.preorderTomorrow')}</span>
          <span className="text-primary font-bold">{hour}</span>
        </div>
      );
    }
    return (
      <div className="truncate">
        <span>{t('deliveryTime.preorderElse', { day })}</span>
        <span className="text-primary font-bold">{hour}</span>
      </div>
    );
  }

  if (isPreorder && !!preorderDeliveryOption) {
    return getPreorderLabel();
  }

  if (isAsap && !!asapDeliveryOption) {
    return (
      <div className="truncate">
        <span>{t('deliveryTime.asap')}</span>
        <span className="text-primary font-bold">
          {asapDeliveryOption.estimatedDeliveryTime?.label}
        </span>
      </div>
    );
  }

  if (isEcommerce) {
    return <span>{t('deliveryTime.ecommerce')}</span>;
  }

  return null;
}
